export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ09.3b5c38f4.mp3";